import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { CollapsibleService } from '../../services/collapsible.service';
import { ViewportService } from '../../services/viewport.service';
import { EmitCollapsibleExpandInterface } from '../../interfaces/emit-collapsible-expand.interface';
import { SLIDE_ANIMATION } from '../../animations/slide.animation';

type animationState = 'open' | 'closed-desktop' | 'closed-mobile';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
  animations: [SLIDE_ANIMATION]
})
export class CollapsibleComponent implements OnInit, OnDestroy {
  @Input() listId: number;
  @Input() itemId: number;
  @Input() closedDesktopHeight = '50px';
  @Input() closedMobileHeight = '50px';
  @Input() time = '300ms';
  @Input() useBoxLayout: boolean;
  @Output() clickEvent = new EventEmitter();
  private expandSubscription: Subscription;
  private isDesktopSubscription: Subscription;
  private finishedClosing = true;
  public isDesktop: boolean;
  public expanded = false;
  public animationState: animationState;

  get displayBottomContent() {
    return this.expanded || !this.finishedClosing;
  }

  constructor(private collapsibleService: CollapsibleService, private viewportService: ViewportService) {}

  ngOnInit() {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      if (this.isDesktop !== value) {
        if (!this.expanded) {
          this.defineClosedAnimationState(value);
        }
      }

      this.isDesktop = value;
    });

    this.expandSubscription = this.collapsibleService.expandObservable.subscribe((value) => {
      this.handleExpandEvent(value);
    });
  }

  ngOnDestroy() {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }

    if (this.expandSubscription) {
      this.expandSubscription.unsubscribe();
    }
  }

  private openCollapsible() {
    this.expanded = true;

    this.animationState = 'open';
  }

  private closeCollapsible() {
    this.finishedClosing = false;

    this.expanded = false;

    this.defineClosedAnimationState(this.isDesktop);

    setTimeout(() => {
      this.finishedClosing = true;
    }, 400);
  }

  private defineClosedAnimationState(isDesktop: boolean) {
    if (isDesktop) {
      this.animationState = 'closed-desktop';
    } else {
      this.animationState = 'closed-mobile';
    }
  }

  private handleExpandEvent(value: EmitCollapsibleExpandInterface) {
    if (this.listId === value.listId && this.itemId !== value.itemId) {
      this.closeCollapsible();
    }
  }

  public handleClick() {
    if (!this.expanded) {
      this.collapsibleService.emitExpand({ listId: this.listId, itemId: this.itemId });

      this.openCollapsible();
    } else {
      this.closeCollapsible();
    }

    this.clickEvent.emit();
  }
}
